// extracted by mini-css-extract-plugin
export default {"faqsSectionLight":"FAQs_faqsSectionLight__LxE5m","faqsSectionDark":"FAQs_faqsSectionDark__EbqU0"};